.icon__container {
  background: none;
  border: none;
  border-radius: 5px;

  text-align: center;
  text-decoration: none;
  display: inline-block;
  height: 40px;
  width: 40px;
}

.icon__container:hover {
  background-color: var(--grey-background);
  cursor: pointer;
}

.icon__img {
  height: 16px;
  width: 16px;
}
